export class LocalStorageKeys {
  public static readonly indexLastUpdated: string = 'index-last-updated';
  public static readonly rememberEmail: string = 'remember-email';
  public static readonly rememberEmailUntil: string = 'remember-email-until';
  public static readonly funnelPeriod: string = 'funnel-period';
  public static readonly funnelComparePeriod: string = 'funnel-compare-period';
  public static readonly startDate: string = 'start-date';
  public static readonly endDate: string = 'end-date';
  public static readonly compareStartDate: string = 'compare-start-date';
  public static readonly compareEndDate: string = 'compare-end-date';
  public static readonly serviceWorkerLogging: string = 'service-worker-logging';
  public static readonly onboardingIndustries: string = 'onboarding-industries';
  public static readonly onboardingGaPropertyId: string = 'onboarding-ga-property-id';
  public static readonly onboardingImportedGaPropertyIds: string = 'onboarding-imported-ga-property-ids';
  public static readonly onboardingChargebeePlanItemPriceId: string = 'onboarding-chargebee-plan-item-price-id';
  public static readonly onboardingPeriodUnit: string = 'onboarding-period-unit';
  public static readonly includedOptionalFilters: string = 'included-optional-filters';
  public static readonly unauthenticatedUrl: string = 'unauthenticated-url';
  public static readonly crossAccount: string = 'cross-account';
  public static readonly allGenerallyAvailable: string = 'all-generally-available';
  public static readonly usagePeriod: string = 'usage-period';
  public static readonly usageComparePeriod: string = 'usage-compare-period';
}
